import { Twitter } from "@mui/icons-material";
import Facebook from "@mui/icons-material/Facebook";
import { Box, Divider, Grid2, IconButton, Link, Typography } from "@mui/material";
import { BOTTOM_LINKS, QUICK_LINKS } from "../../_const/footerLinks.const";
import { footerStyles } from "../../_styles/footer.styles";

export default function AppFooter() {

    return (
        <Box component="footer" sx={footerStyles.mainContainer}>

            <Box sx={{ width: "100%", maxWidth: 1200, mx: "auto", textAlign: "left" }}>

                <Grid2 container spacing={{ xs: 2, sm: 4 }}>

                    <Grid2 size={{ xs: 12, sm: 8 }}>

                        <Typography variant="h5" sx={footerStyles.subTitle}>QUICK LINKS</Typography>

                        <Grid2 container columns={12} spacing={{ xs: 1, sm: 2 }}>
                            {QUICK_LINKS.map((item) => (
                                <Grid2 key={item.label} size={{xs: 12, sm: 5}}>
                                    <Typography
                                        variant="h6"
                                        sx={{ wordBreak: "break-word" }}
                                    >
                                        <Link href={item.href}>{item.label}</Link>
                                    </Typography>
                                </Grid2>
                            ))}
                        </Grid2>

                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 4 }}>

                        <Typography variant="h5" sx={footerStyles.subTitle}>CONTACT</Typography>

                        <Typography variant="h6" sx={{ fontSize: { xs: "0.95rem", sm: "1rem" } }}>
                            056 7770777
                        </Typography>

                        <Typography variant="h6" sx={{ marginBottom: { xs: "8px", sm: "10px" } }}>
                            <Link href="mailto:mwalsh@heritagecouncil.ie">mwalsh@heritagecouncil.ie</Link>
                        </Typography>

                        <Box>
                            <IconButton href="https://www.facebook.com/TheHeritageCouncil"><Facebook fontSize="large"/></IconButton>
                            <IconButton href="https://x.com/HeritageHubIRE"><Twitter fontSize="large" /></IconButton>
                        </Box>

                    </Grid2>



                </Grid2>

                <Divider sx={{ my: { xs: 2, sm: 3 }, borderColor: "rgba(255,255,255,0.2)" }} />

                <Box
                    sx={footerStyles.bottomContainer}
                >
                    <Typography variant="body1">
                        &copy; {new Date().getFullYear()} The Heritage Council, &Aacute;ras na hOidreachta, Church Lane, Kilkenny. All Rights Reserved.
                    </Typography>

                    {BOTTOM_LINKS.map((l, i, arr) => (
                        <div key={l.label} style={{paddingLeft: "8px"}}>
                            <Link href={l.href}>{l.label}</Link>
                        </div>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};
